<template>
  <div>Gizli Müşteri</div>
</template>
<script>
export default {
  name: 'IndexPage',
}
</script>
